// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TlEn","content":"styles_content__2Q0Bj"};